import { bool, func } from 'prop-types'
import Button from '../../Button'
import { noPropagate } from '../../utils'

const RestoreButton = ({ onRestore, restorable, restoring }) => {
  if (restorable) {
    const clickHandler = restoring ? () => {} : noPropagate(onRestore)
    const tooltipText = restoring ? 'Restoring...' : 'Restore Version'
    return (
      <Button
        onClick={clickHandler}
        className="restore"
        themeClass="light"
        tooltip={tooltipText}
        icon="restore"
        type="invisible"
      />
    )
  }
  return null
}

RestoreButton.propTypes = {
  onRestore: func,
  restorable: bool,
  restoring: bool,
}

export default RestoreButton
